import { Link as RouterLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Grid, Link, Skeleton, Typography, useTheme } from '@mui/material'

import { useAccount } from 'src/hooks'

import { FONTS, ROUTES, SPACES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { countItems } from './items'
import { ETranslationNs } from 'src/types'

const ItemsStatistic = () => {
  const [t] = useTranslation(ETranslationNs.Navbar)
  const { data: account } = useAccount()
  const theme = useTheme()

  return (
    <Grid
      container
      flexDirection={'row'}
      justifyContent="space-between"
      display={'flex'}
      pl={'0.55rem'}
      mb={SPACES.xxxxxl}
    >
      {countItems.map((item, index) => (
        <Grid
          item
          container
          display={'flex'}
          flexDirection={'row'}
          width={'16%'}
          minHeight={'4.7rem'}
          key={index}
          alignItems="center"
          pl={SPACES.xxl}
        >
          <Grid item mr={SPACES.xl} pb={SPACES.xxs}>
            {item.icon({ isSmall: true })}
          </Grid>
          <Grid item>
            {account ? (
              <Typography
                fontSize={FONTS.SIZES.xxxxxl}
                fontWeight={FONTS.WEIGHTS.bold}
                color={theme.palette.custom.darkBlue2}
              >
                {account[item.count]}
              </Typography>
            ) : (
              <Skeleton variant="text" sx={{ fontSize: FONTS.SIZES.xxxxxl, width: 24 }} />
            )}
            <Link
              component={RouterLink}
              underline="none"
              fontSize={FONTS.SIZES.s}
              fontWeight={FONTS.WEIGHTS.bold}
              color={theme.palette.custom.grey2}
              to={joinAbsRoute(ROUTES.ACCOUNTS, account?.id, item.link)}
            >
              {t(item.title)}
            </Link>
          </Grid>
        </Grid>
      ))}
    </Grid>
  )
}

export { ItemsStatistic }
